export const handleMessageError = (error: any): string => {
    if (typeof error === 'string') return error
    const message = 'Error desconocido al realizar la acción.'
    if (error.response && 'data' in error.response && 'message' in error.response.data)
        return error.response.data.message
    if ('message' in error) return error.message

    return message
}
